var React = require('react');

function CheckboxChecked (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","y":"2","width":"20","height":"20","rx":"4","fill":"#1BE3AD","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L10 17.4142L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L10 14.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289Z","fill":"black","key":1})]);
}

CheckboxChecked.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckboxChecked;

CheckboxChecked.default = CheckboxChecked;
